<template>
  <v-container
    fluid
    style="height: 100%;"
    class="pl-0 pr-2 py-0 m-0 box"
    align-stretch
  >
  <!-- <v-layout
      row
      wrap
      ma-0
      py-4
      py-0
    >
      <v-flex xs12>
        <p class="font-weight-medium my-0 ml-4"> สรุปอุบัติเหตุตามช่วงเวลา </p>
      </v-flex>
  </v-layout>-->

  <v-layout row wrap ma-0 py-4 py-0>
    <v-flex xs12>
      <p class="font-weight-medium my-0 ml-4 float-left">สรุปการเกิดอุบัติเหตุและเสียชีวิต จำแนกตามจังหวัด</p>
      <v-tooltip right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            color="primary"
            dark
            class="ml-1"
            v-bind="attrs"
            v-on="on"
            >fa-info-circle</v-icon
          >
        </template>
        <span>สนับสนุนการกรองข้อมูลตามยานพาหนะที่เกิดเหตุ</span>
      </v-tooltip>
      <v-card class="d-flex justify-center my-2 px-4" flat>
        <v-expansion-panels
          multiple
          v-model="occurPanel"
          class="rectangle"
          v-for="(item, i) in chartOccur"
          :key="i"
          :class="{ 'ml-4': i != 0 }"
        >
          <v-expansion-panel @click="toggleOccurPanel()">
            <v-expansion-panel-header flex class="title-dropdown rectangle-border">
              <!-- <v-icon style="display: contents;" color="#BA4438" @click="removeAccident(i)"
                        >highlight_off</v-icon
              >-->
              {{ item.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content pa-0 class="rectangle-border">
              <v-flex text-center v-if="occurLoading">
                <v-progress-circular
                  size="70"
                  width="7"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
              <v-layout ma-0 pt-1 v-for="(p, j) in item.list" :key="j">
                <v-flex xs8>
                  <p class="subtitle-1 my-0 py-0">{{ j + 1 }}. {{ p.name }}</p>
                </v-flex>
                <v-flex xs4>
                  <p class="my-0 py-0 subtitle-1 number text-right">
                    {{ p.amount | numFormat }} {{ item.unit }}
                  </p>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>

      <v-card
        class="d-flex justify-center my-2 px-4"
        flat
        v-if="!(searchCondition && searchCondition.isBMTA)"
      >
        <v-expansion-panels
          multiple
          v-model="nonePanel"
          class="rectangle"
          v-for="(item, i) in chartNone"
          :key="i"
          :class="{ 'ml-4': i != 0 }"
        >
          <v-expansion-panel @click="toggleNonePanel()">
            <v-expansion-panel-header flex class="title-dropdown rectangle-border">
              <!-- <v-icon style="display: contents;" color="#BA4438" @click="removeAccident(i)"
                        >highlight_off</v-icon
              >-->
              {{ item.name }}
            </v-expansion-panel-header>
            <v-expansion-panel-content pa-0 class="rectangle-border">
              <v-flex text-center v-if="noneLoading">
                <v-progress-circular
                  size="70"
                  width="7"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </v-flex>
              <v-layout ma-0 pt-1 v-for="(p, j) in item.list" :key="j">
                <v-flex xs8>
                  <p class="subtitle-1 my-0 py-0">{{ j + 1 }}. {{ p }}</p>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Cause',
  props: {
    searchCondition: {
      type: Object
    }
  },
  data: () => ({
    title: 'มูลเหตุสันนิฐาน',
    chartOptions: null,
    chartOccur: [],
    chartNone: [],
    occurPanel: [],
    nonePanel: [],
    occurLoading: false,
    noneLoading: false
  }),
  created() {
    this.getInitChart();
    this.getChartOptions();
  },
  mounted() {},
  methods: {
    toggleOccurPanel() {
      if (this.occurPanel.count == 0) {
        this.occurPanel = [0, 1, 2];
      }
    },
    toggleNonePanel() {
      if (this.nonePanel.count == 0) {
        this.nonePanel = [0, 1, 2];
      }
    },
    getChartOptions() {
      this.chartOptions = {
        chart: {
          type: 'pie',
          renderTo: 'container'
        },
        title: {
          verticalAlign: 'middle',
          floating: false,
          text: '12%'
        },
        plotOptions: {
          pie: {
            innerSize: '70%',
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: false,
            showInLegend: false
          }
        },
        series: [
          {
            data: [
              ['Chrome', 3.1],
              ['Other', 5.4]
            ]
          }
        ]
      };
    },
    getInitChart() {
      this.chartOccur = [
        {
          name: 'จังหวัดที่มีอุบัติเหตุสูงสุด',
          code: 'accident',
          unit: 'ครั้ง',
          list: []
        },
        {
          name: 'จังหวัดที่มีผู้เสียชีวิตจากอุบัติเหตุสูงสุด',
          code: 'dead',
          unit: 'คน',
          list: []
        },
        {
          name: 'จังหวัดที่มีผู้บาดเจ็บจากอุบัติเหตุสูงสุด',
          code: 'injury',
          unit: 'คน',
          list: []
        }
      ];
      this.chartNone = [
        {
          name: 'จังหวัดที่ไม่เกิดอุบัติเหตุ',
          code: 'accident',
          list: []
        },
        {
          name: 'จังหวัดที่ไม่มีผู้เสียชีวิตจากอุบัติเหตุ',
          code: 'dead',
          list: []
        },
        {
          name: 'จังหวัดที่ไม่มีผู้บาดเจ็บจากอุบัติเหตุ',
          code: 'injury',
          list: []
        }
      ];
    },
    search() {
      this.getInitChart();
      this.getChartOptions();
      this.searchChartOccur();
      if (!(this.searchCondition && this.searchCondition.isBMTA)) {
        this.searchChartNone();
      }
    },
    searchChartOccur() {
      const scope = this;
      this.occurLoading = true;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/chart/province/occur`;
      // if (this.searchCondition != null && this.searchCondition.start_date) {
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // }
      // if (this.searchCondition != null && this.searchCondition.end_date) {
      //   url += `end_date=${this.searchCondition.end_date}&`;
      // }

      const params = { lazy: true };
      for (const i in this.searchCondition) {
        params[i] = this.searchCondition[i];
      }

      this.axios
        .get(url, { params })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            if (this.isCurrentCondition(response.config.params)) {
              const { data } = response.data;
              scope.chartOccur = scope.chartOccur.map(item => {
                let list = data[item.code];
                list = list.map(el => {
                  let province = el.name.split(',').map(a => a.trim());
                  province.sort((a, b) => a.localeCompare(b));
                  el.name = province.join(', ');
                  return el;
                });
                item.list = list;
                return item;
              });
              scope.occurLoading = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    searchChartNone() {
      const scope = this;
      this.noneLoading = true;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/chart/province/none`;
      // if (this.searchCondition != null && this.searchCondition.start_date) {
      //   url += `start_date=${this.searchCondition.start_date}&`;
      // }
      // if (this.searchCondition != null && this.searchCondition.end_date) {
      //   url += `end_date=${this.searchCondition.end_date}&`;
      // }
      const params = { lazy: true };
      for (const i in this.searchCondition) {
        params[i] = this.searchCondition[i];
      }

      this.axios
        .get(url, { params })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            if (this.isCurrentCondition(response.config.params)) {
              const { data } = response.data;
              scope.chartNone = scope.chartNone.map(item => {
                item.list = data[item.code];
                item.list.sort((a, b) => a.localeCompare(b));
                return item;
              });
              scope.noneLoading = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    isCurrentCondition(params) {
      delete params.lazy;
      if (Object.keys(params).length == Object.keys(this.searchCondition).length) {
        for (const i in params) {
          if (params[i] != this.searchCondition[i]) {
            return false;
          }
          return true;
        }
      } else {
        return false;
      }
    }
  },
  watch: {
    searchCondition() {
      this.search();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.v-tab {
  background-color: white;
  color: #ba4438;
}

.v-tab.v-tab--active {
  background-color: #ba4438;
  color: white;
}

.search {
  float: right;
}

.detail {
  background: var(--v-brightgrey-base);
}

.number {
  color: #ba4438;
}

.chart {
  margin-top: 10px;
  margin-bottom: 10px;
}

.sub-menu {
  width: 32px;
  height: 32px;
  margin: auto;
  top: calc(50% - 16px);
}

.rectangle {
  width: 100%;
  // height: 600px;
  border-radius: 3px;
  // border: solid 1px #ba4438;
}

.rectangle-border {
  border: solid 1px #ba4438;
}

.title-dropdown {
  color: white;
  background-color: #ba4438;
  padding: 16px 8px;
}

.charts {
  height: 150px;
}

.charts-pie {
  height: 260px;
}

.v-expansion-panel-content {
  padding: 10px 0 0 0;
}
</style>
